import  Petition  from "../../../modules/petition";

const pet = new Petition();
export class apiService {
    async executeGet(endpoint: any){
        return await pet.get(endpoint);
    }

    async executePost(endpoint: any, data: object){
        return await pet.post(endpoint, data);
    }
}